(function () {
  function initDmSaleRibbon() {
    document.querySelectorAll('[data-dm-variants-json-sale]').forEach((jsonEl) => {
      const section = jsonEl.closest('section');
      if (!section) return;

      const ribbon = section.querySelector('[data-dm-sale-ribbon]');
      const textEl = section.querySelector('[data-dm-sale-ribbon-text]');
      if (!ribbon || !textEl) return;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent || '[]');
      } catch (e) {
        return;
      }

      function getSelectedVariantId() {
        const idInput = section.querySelector('input[name="id"]');
        return idInput ? Number(idInput.value) : null;
      }

      function update() {
        const id = getSelectedVariantId();
        const v = variants.find(x => Number(x.id) === Number(id));
        if (!v) return;

        const price = Number(v.price || 0);
        const compare = Number(v.compare_at_price || 0);

        if (compare > price && compare > 0) {
          const pct = Math.round(((compare - price) * 100) / compare);
          textEl.textContent = `-${pct}%`;
          ribbon.hidden = false;
        } else {
          ribbon.hidden = true;
        }
      }

      // Initial + variant changes
      update();
      document.addEventListener('variant:change', update);

      section.addEventListener('change', (e) => {
        if (e.target && (e.target.name === 'id' || e.target.closest('variant-selects') || e.target.closest('variant-radios'))) {
          update();
        }
      });

      const idInput = section.querySelector('input[name="id"]');
      if (idInput) {
        const obs = new MutationObserver(update);
        obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDmSaleRibbon);
  } else {
    initDmSaleRibbon();
  }
})();